/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const ErrorCode = zod
  .enum([
    'invalid_request',
    'unauthorized',
    'session_expired',
    'no_access',
    'forbidden',
    'password_change_required',
    'impersonation_ended',
    'clinic_inactive',
    'challenge_required',
    'blocked',
    'booking_cap_reached',
    'not_found',
    'pf_appointment_not_found',
    'conflict',
    'slot_taken',
    'hold_expired',
    'request_in_progress',
    'idempotency_key_reused',
    'rate_limited',
    'internal_error',
    'pf_error',
    'booking_unconfirmed',
    'pf_unavailable',
  ])
  .describe('API.md §1.6: the complete list of HTTP error codes.')

export type ErrorCode = zod.input<typeof ErrorCode>
export type ErrorCodeOutput = zod.output<typeof ErrorCode>
